import { useNavigate } from "react-router";
import { useAuth } from "./AuthProvider";

export function SignOutLink() {
  const { me, signOut } = useAuth();
  const navigate = useNavigate();
  const signInPath = me?.surface === "portal" ? "/portal/signin" : "/signin";

  return (
    <button
      className="linkish"
      type="button"
      onClick={async () => {
        await signOut();
        navigate(signInPath, { replace: true });
      }}
    >
      Sign out
    </button>
  );
}
